import { createHead } from '@vueuse/head';
import { VueMaskDirective } from 'v-mask';
import { createApp } from 'vue';
import VueGtag from 'vue-gtag';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import countTo from 'vue3-count-to';
import App from './App.vue';
import './assets/css/bootstrap.min.css';
import './assets/css/font-awesome.min.css';
import './assets/css/jquery-te.css';
import './assets/css/main.css';
import './assets/css/responsive.css';
import './assets/css/slick.css';
import './assets/css/tokens.css';
import router from './router';
import store from './store';

const vMaskV2 = VueMaskDirective;

const head = createHead()

const toastOptions = {};
const vMaskV3 = {
  beforeMount: vMaskV2.bind,
  updated: vMaskV2.componentUpdated,
  unmounted: vMaskV2.unbind,
};

createApp(App)
  .use(store)
  .use(head)
  .use(router)
  .use(Toast, toastOptions)
  .use(countTo)
  .use(VueGtag, { config: { id: 'G-32VCSB8M0F' } }, router)
  .directive('mask', vMaskV3)
  .mount('#app');
